import React, {Fragment} from 'react';
import TarifarioYDisponibilidad from 'components/nuevoTarifario/TarifarioYDisponibilidad';
import DialogoPantallaCompleta from 'components/Dialogo/DialogoPantallaCompleta';
import DatosDemograficos from 'components/nuevoTarifario/DatosDemograficos';
import PasoAPasoHorizontal from 'components/pasoAPasoHorizontal';
import { Card, CardContent, Typography } from '@mui/material';
import Cobertura from 'components/nuevoTarifario/Cobertura';
import { useSelector } from 'react-redux';
import DatosDeLaRadio from 'components/nuevoTarifario/DatosDeLaRadio';

const NuevaRadio= ({title, openFullScreenDialog, handleClose, datosDeEmpresa, ...rest}) => {
  const {activeStep, numberStep, datosDeLaRadio, tarifarioYDisponibilidad, datosDemograficos, cobertura,} = useSelector( ({nuevoTarifario}) => nuevoTarifario);

  const obtenerContenidoDePasos = (step) => {
    switch (step) {
      case 0:
        return <DatosDeLaRadio activeStep={activeStep} numberStep={numberStep} handleClose={handleClose} datosDeLaRadio={datosDeLaRadio} />
      case 1:
        return renderizarAlSiguientePaso(rest.steps[step])
      case 2:
        return renderizarAlSiguientePaso(rest.steps[step])
      case 3:
        return renderizarAlSiguientePaso(rest.steps[step])
      default:
        return <Typography>No existen Componente para mostrar</Typography>;
    }
  }

  const renderizarAlSiguientePaso = (currentStep) => {
    switch(currentStep?.id) {
      case 1:
        return <TarifarioYDisponibilidad activeStep={activeStep} numberStep={numberStep} handleClose={handleClose} tarifarioYDisponibilidad={tarifarioYDisponibilidad} tipoMedio="radio"  />
      case 2:
        return <Cobertura activeStep={activeStep} numberStep={numberStep} handleClose={handleClose} cobertura={cobertura}/>
      case 3:
        return <DatosDemograficos activeStep={activeStep} numberStep={numberStep} handleClose={handleClose} datosDelMedio={datosDeLaRadio} tarifarioYDisponibilidad={tarifarioYDisponibilidad} cobertura={cobertura} datosDemograficos={datosDemograficos} tituloModalDeConfirmacion="una nueva radio" tarifario="de la radio" tipoMedio="radio" nitEmpresa={datosDeEmpresa.nit} />
      default:
        return <Typography>No existen Componente para mostrar</Typography>;
    }
  }

  const cerrarPantallaCompleta = function() { handleClose() }

  return (
    <DialogoPantallaCompleta
        openFullScreenDialog={openFullScreenDialog}
        handleClose={cerrarPantallaCompleta}
        title={title}
        fullscreen={true}
    >
      <Fragment>
          <Card>
              <CardContent>
                  <PasoAPasoHorizontal
                      cerrarPantallaCompleta={cerrarPantallaCompleta}
                      steps={rest.steps}
                      obtenerContenidoDePasos={obtenerContenidoDePasos}
                      activeStepProp={activeStep}
                      numberStepProp={numberStep}
                      showButtonStepper={false}
                  />
              </CardContent>
          </Card>
      </Fragment>
    </DialogoPantallaCompleta>
  );
}

export default NuevaRadio;